import { z } from 'zod';
import type { ClientInfoPageData } from './types';

const ClientPreferencesSchema = z.object({
  drives: z.boolean().optional(),
  walkability_preference: z.number().optional(),
  public_transit_importance: z.number().optional(),
  has_children: z.boolean().optional(),
  children_ages: z.array(z.number()).optional(),
  school_district_priority: z.boolean().optional(),
  budget_min: z.number().optional(),
  budget_max: z.number().optional(),
  property_types: z.array(z.enum(['house', 'townhouse', 'condo'])).optional(),
  min_bedrooms: z.number().optional(),
  min_bathrooms: z.number().optional(),
  amenity_preferences: z.array(z.string()).optional(),
  work_address: z.string().optional(),
  max_commute_minutes: z.number().optional(),
  interested_in_schools: z.boolean().optional(),
  school_level_preference: z.enum(['elementary', 'middle', 'high', 'all']).optional(),
  interested_in_rentals: z.boolean().optional(),
  interested_in_investment: z.boolean().optional(),
  pet_friendly: z.boolean().optional(),
  parking_required: z.boolean().optional(),
  accessibility_needs: z.boolean().optional(),
});

const ClientInfoPageAgentSchema = z.object({
  uuid: z.string(),
  name: z.string(),
  first_name: z.string(),
  last_name: z.string(),
  photo_url: z.string().optional(),
  phone: z.string().optional(),
  email: z.string().optional(),
  website_url: z.string().optional(),
  affiliate_handle: z.string().optional(),
});

const DisplayPreferencesSchema = z.object({
  show_market_stats: z.boolean().optional(),
  show_property_inventory: z.boolean().optional(),
  show_price_trends: z.boolean().optional(),
  show_top_neighbourhoods: z.boolean().optional(),
  show_agent_contact_card: z.boolean().optional(),
  show_client_preferences: z.boolean().optional(),
  show_recommended_listings: z.boolean().optional(),
  show_area_blurb: z.boolean().optional(),
  show_nearby_schools: z.boolean().optional(),
  show_walkability_info: z.boolean().optional(),
  show_rental_market: z.boolean().optional(),
  show_investment_stats: z.boolean().optional(),
});

export const ClientInfoPageDataSchema: z.ZodType<ClientInfoPageData> = z.object({
  uuid: z.string(),
  area_slug: z.string(),
  client_name: z.string(),
  client_preferences: ClientPreferencesSchema,
  custom_message: z.string().optional(),
  expires_at: z.string().optional(),
  view_count: z.number(),
  created_at: z.string(),
  agent: ClientInfoPageAgentSchema,
  display_preferences: DisplayPreferencesSchema.optional(),
});

export const ClientInfoPageErrorSchema = z.object({
  error: z.string(),
});
